<template>
  <div>
    <myheader headTitle="文件签署"></myheader>
    <div class="all_main">
      <div
        class="all_height20"
        style="
          position: fixed;
          top: 4rem;
          left: 0;
          right: 0;
          background-color: white;
          z-index: 10;
          display: flex;
          padding: 0 0.5rem;
        "
      >
        <div
          @click="showSelectFile()"
          class="all_height20 display_flex display_inline_block"
          style="width: 48%; overflow: hidden; padding: 0.6rem 0"
        >
          <img
            src="@/assets/images/dropdown.svg"
            style="
              display: inline-block;
              width: 8%;
              padding-top: 0.2rem;
              object-fit: contain;
            "
            :class="{ rotate: reslistShow }"
          />
          <div
            class="text12 textcolor333 display_inline_block"
            style="
              width: 90%;
              height: 0.8rem;
              margin-left: 2%;
              overflow: hidden;
            "
          >
            {{ resText }}
          </div>
        </div>
        <div
          class="text12 textcolor999 all_line_height12"
          style="
            display: inline-block;
            width: 27%;
            text-align: right;
            padding: 0.4rem 0;
          "
        >
          {{ "共" + resList.length + "份文件待签署" }}
        </div>
        <div
          style="
            display: inline-block;
            width: 25%;
            display: flex;
            padding: 0.4rem 0;
          "
        >
          <span
            @click="prevFileClick()"
            class="text12 all_text_center all_line_height12"
            style="display: inline-block; width: 49.8%"
            :class="{
              textcolormain: currentShowDoc.prevIframeID,
              textcolor999: !currentShowDoc.prevIframeID,
            }"
          >
            上一篇</span
          >
          <span
            class="vertical_line"
            style="display: inline-block; width: 0.4%"
          ></span>
          <span
            @click="nextFileClick()"
            class="text12 all_text_center all_line_height12"
            style="display: inline-block; width: 49.8%"
            :class="{
              textcolormain: currentShowDoc.nextIframeID,
              textcolor999: !currentShowDoc.nextIframeID,
            }"
            >下一篇</span
          >
        </div>
      </div>
      <div
        class="all_list_content_nopadding"
        id="pdfcontainer"
        style="top: 6.2rem; bottom: 0; background-color: white"
      ></div>
      <div
        id="reslist"
        style="
          position: absolute;
          left: 0;
          right: 0;
          background-color: white;
          transition: top 0.3s linear 0s;
        "
        :style="{ top: reslistTop }"
      >
        <div class="horizontal_line"></div>
        <div
          v-for="(item, index) in resList"
          :key="index"
          @click="selectEditFileIndex(item, index)"
        >
          <div
            class="text12 all_height_line16"
            style="
              padding: 0 0.5rem;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            :class="{
              textcolor333: currentShowDocIndex === index,
              textcolor999: currentShowDocIndex != index,
            }"
          >
            {{ item.resName }}
          </div>
          <div class="horizontal_line"></div>
        </div>
      </div>
    </div>
    <van-popup v-model:show="pop_show" round :style="{ width: '80%' }">
      <div class="sms_pop_parent" @click.stop>
        <div>
          <div class="all_height_line14 margin_top_5 margin_bottom_5">
            <span
              class="all_text_center all_line_height14 text14 textcolor333 font_weight_bold"
              style="display: inline-block; width: 26%; margin-left: 38%"
              >验证码签约</span
            >
          </div>
          <div class="horizontal_line margin_top_5"></div>
          <div class="pop_content margin_top_5">
            <div
              class="all_input all_height30"
              :class="{ isfocus: verifyFocus }"
            >
              <div class="display_inline_block" style="width: 55%">
                <van-field
                  type="number"
                  placeholder="请输入计算结果"
                  v-model="verifyCode"
                  @focus="getFocus(1)"
                  @blur="onblur(1)"
                  maxlength="6"
                  clearable
                >
                </van-field>
              </div>
              <span
                @click="getPictureImg()"
                class="display_inline_block"
                title="看不清,换一个"
                style="width: 40%"
              >
                <img
                  :src="verifyImg"
                  style="height: 2rem; width: 5rem"
                  fill
                  title="看不清,换一个"
              /></span>
            </div>
            <div class="all_input all_height30" :class="{ isfocus: codeFocus }">
              <div class="display_inline_block" style="width: 50%">
                <van-field
                  v-model="smsCode"
                  type="number"
                  maxlength="6"
                  placeholder="请输入验证码"
                  clearable
                  @focus="getFocus(2)"
                  @blur="onblur(2)"
                />
              </div>
              <span
                @click="getCode()"
                class="display_inline_block text14 all_text_right all_line_height20"
                style="width: 45%"
                :class="{
                  textcolormain: timer === 60,
                  textcolor999: timer != 60,
                }"
              >
                {{ timer === 60 ? "获取验证码" : timer + "s后再次获取" }}</span
              >
            </div>
          </div>
          <div class="margin_top_10 margin_bottom_5 all_height20">
            <button
              id="switchFAuth"
              ref="switchFAuth"
              class="text14 all_line_height20 textcolorwhite backgroundC_main"
              style="
                display: inline-block;
                width: 35%;
                margin-left: 5%;
                border-radius: 5px;
                visibility: hidden;
              "
              @click="switchFaceAuth()"
            >
              切换人脸认证
            </button>
            <button
              class="text14 all_line_height20 textcolormain backgroundC_#f2f2f2"
              style="
                display: inline-block;
                width: 25%;
                margin-left: 3%;
                border-radius: 5px;
              "
              @click="dimiss()"
            >
              取消
            </button>
            <button
              class="text14 all_line_height20 textcolorwhite backgroundC_main"
              style="
                display: inline-block;
                width: 25%;
                margin-left: 2%;
                border-radius: 5px;
              "
              @click="popSumbit()"
            >
              确定
            </button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Field,
  Dialog
} from 'vant';
import {
  realLiveAuth,
  initIosAuth
} from '../../utils/nativeRealLiveAuth.js';
import {
  getSealHashSign
} from '../../utils/nativeCertSign.js';
import {
  setEssToken
} from "../../utils/cookies.js";
export default {
  name: 'ContractSignSeal',
  components: {
    [Field.name]: Field,
  },
  data() {
    return {
      //合同id
      //contractId: '',
      //企业id
      //corpId: '',
      //
      corpsId: '',
      //合同类型
      bizId: 'CMIS',
      //合同类型(0-原始合同,1-变更合同,2-转让合同,3-终止合同)(物流平台: 0-收货单 1-发货单)'
      //bizId=LOGISTICS 的时候判断 
      //contract_type=0 : signetType=1收货章，contract_type=1 : signetType=2 发货章
      contractType: 0,
      //页面路由appCode,
      //appCode: '',
      //页面路由token,
      //token: '',
      //提交数据缓存
      //resId: '',
      //合同详情
      contractInfo: '',
      //当前用户是否属于当前合同当前公司是否有权限签名
      isSigner: false,
      //当前用户是否属于当前合同当前公司是否有权限盖章
      isSealer: false,
      //文件列表top值
      reslistTop: 0,
      //文件列表是否显示
      reslistShow: false,
      //文档列表
      resList: [],
      //选中文档名称
      resText: '',
      //当前iframe 对象
      currentShowDoc: '',
      //当前iframe index
      currentShowDocIndex: 0,
      //所有文档iframe  map对象
      currentDocumentObject: {},
      //签章后刷新页面恢复滑动高度
      currentDocumentScrollTop: [],
      //0签名 1盖章 
      keyType: -1,
      keyTypeName: '签名',
      // VIEW 查看 SIGN 签署
      type: 'SIGN',
      //签名盖章数据
      submitData: {
        models: []
      },
      //iframe高度
      iframeHeight: '85vh',
      //限制多文件活体认证只调用一次
      limitFaceAuth: true,
      //活体认证token
      verifyToken: '',
      //
      timeOutEvent: null,
      //
      pop_show: false,
      //验证码倒计时
      timer: 60,
      //
      timerInterval: null,
      //图片验证结果
      verifyCode: '',
      //验证Id
      verifyId: '',
      //验证图片
      verifyImg: '',
      //验证码
      smsCode: '',
      //
      codeFocus: false,
      verifyFocus: false,
      //
      clickId: '',
      //
      retryIndex: 0,
      //
      retryCount: 0,
    }
  },
  methods: {
    //
    popShow(flag = false) {
      this.smsCode = ''
      this.getPictureImg()
      this.pop_show = true
      if (flag) {
        setTimeout(() => {
          document.getElementById('switchFAuth').style.visibility = 'visible'
          if (plus.os.name === 'iOS') {
            document.getElementById('switchFAuth').style.opacity = '0'
            document.getElementById('switchFAuth').style.pointerEvents = 'none'
          }
        }, 200)
      }
    },
    //
    getPictureImg() {
      this.verifyCode = ''
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealg('/api/sms/verifyImg', {}, this.submitData.models[0].params.appCode).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.verifyId = res.data.verifyId
          this.verifyImg = res.data.srcImg
        } else {
          this.verifyImg = ''
          this.$Toast("未获取到验证图片！");
        }
      }).catch((err) => {
        this.verifyImg = ''
        this.$store.dispatch(this.$LoadShow, false)
        console.log('verifyImg', err)
      });
    },
    //
    switchFaceAuth() {
      this.faceCompareAuth()
    },
    //
    getFocus(id) {
      if (id == 1) {
        this.verifyFocus = true;
      } else if (id == 2) {
        this.codeFocus = true;
      }
    },
    //
    onblur(id) {
      if (id == 1) {
        this.verifyFocus = false;
      } else if (id == 2) {
        this.codeFocus = false;
      }
    },
    //
    dimiss() {
      this.timer = 60;
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
      }
      this.verifyCode = ''
      this.smsCode = ''
      this.pop_show = false
    },
    //
    getCode() {
      let that = this
      if (this.timer != 60) {
        return
      }
      if (!this.verifyId || !this.verifyCode) {
        this.$Toast("请输入图片验证码计算结果！");
        return
      }
      this.smsCode = ''
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealp("/api/sms/sendCode", JSON.stringify({
        staffId: this.submitData.models[0].params.staffId,
        resId: this.submitData.models[0].params.resId,
        corpId: this.submitData.models[0].params.corpId,
        verify: {
          id: this.verifyId,
          code: this.verifyCode
        }
      }), this.submitData.models[0].params.appCode).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success) {
          this.$Toast("验证码已发送，请注意查收！");
          this.timer--;
          this.timerInterval = setInterval(() => {
            this.timer--;
            if (this.timer == 0) {
              this.timer = 60;
              clearInterval(that.timerInterval)
            }
          }, 1000);
        } else {
          this.$Toast(res.message || res.messageDetail || "获取验证码失败！");
          this.getPictureImg()
        }
      }).catch(err => {
        this.$store.dispatch(this.$LoadShow, false)
        this.getPictureImg()
        console.log('/api/sms/sendCode', err)
      });
    },
    //
    popSumbit() {
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealp("/api/sms/verifyCode", JSON.stringify({
        staffId: this.submitData.models[0].params.staffId,
        resId: this.submitData.models[0].params.resId,
        smsCode: this.smsCode,
        corpId: this.submitData.models[0].params.corpId
      }), this.submitData.models[0].params.appCode).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success && res.data) {
          this.timer = 60;
          if (this.timerInterval) {
            clearInterval(this.timerInterval)
          }
          this.verifyToken = res.data
          this.pop_show = false
          this.getSignFileHash(0)
        } else {
          this.$Toast(res.message || res.messageDetail || "获取验证码失败！");
          this.getPictureImg()
        }
      }).catch(err => {
        this.$store.dispatch(this.$LoadShow, false)
        this.getPictureImg()
        console.log('/api/sms/verifyCode', err)
      });
    },
    //上一篇
    prevFileClick() {
      //console.log(this.currentShowDoc)
      this.dimissFileList()
      if (this.currentShowDoc.prevIframeID) {
        const previousIs = this.currentDocumentObject[this.currentShowDoc.prevIframeID];
        document.getElementById(previousIs.currentIframeName).style.display = 'block';
        document.getElementById(this.currentShowDoc.currentIframeName).style.display = 'none';
        // setTimeout(()=>{
        // },100)
        this.currentShowDoc = previousIs;
        document.getElementById(this.currentShowDoc.currentIframeName).contentWindow.optimizePageShow()
        this.currentShowDocIndex = this.currentShowDoc.originIdx
        this.resText = this.currentShowDoc.documentName
      } else {
        //this.$Toast('当前已是第一份文档');
      }
    },
    //下一篇
    nextFileClick() {
      //console.log(this.currentShowDoc)
      this.dimissFileList()
      if (this.currentShowDoc.nextIframeID) {
        const nextIs = this.currentDocumentObject[this.currentShowDoc.nextIframeID];
        document.getElementById(nextIs.currentIframeName).style.display = 'block';
        document.getElementById(this.currentShowDoc.currentIframeName).style.display = 'none';
        this.currentShowDoc = nextIs;
        document.getElementById(this.currentShowDoc.currentIframeName).contentWindow.optimizePageShow()
        this.currentShowDocIndex = this.currentShowDoc.originIdx
        this.resText = this.currentShowDoc.documentName
      } else {
        //this.$Toast('当前已是最后一份文档')
      }
    },
    //隐藏文件列表
    dimissFileList() {
      if (this.reslistShow) {
        //document.getElementById('reslist').style.visibility = 'hidden'
        let fontsize = document.firstElementChild.style.fontSize.replace('px', '')
        this.reslistTop = Number(fontsize) * 6 - document.getElementById("reslist").clientHeight + 'px'
        this.reslistShow = false
      }
      window.localStorage.setItem('ResListShow', this.reslistShow)
    },
    //显示文件列表
    showSelectFile() {
      //console.log(window.getComputedStyle())
      //console.log(window)
      console.log('--showSelectFile--', this.reslistShow)
      // console.log('--showSelectFile--', document.getElementById('reslist'))
      // console.log('--showSelectFile--', document.getElementById('reslist').style)
      if (this.reslistShow) {
        //document.getElementById('reslist').style.visibility = 'hidden'
        let fontsize = document.firstElementChild.style.fontSize.replace('px', '')
        this.reslistTop = Number(fontsize) * 6 - document.getElementById("reslist").clientHeight + 'px'
        this.reslistShow = false
      } else {
        //document.getElementById('reslist').style.visibility = 'visible'
        this.reslistTop = '6rem'
        this.reslistShow = true
      }
      window.localStorage.setItem('ResListShow', this.reslistShow)
    },
    //选择签署文件
    selectEditFileIndex(item, index) {
      this.resText = item.resName
      if (item.docId != this.currentShowDoc.documentID) {
        const nextIs = this.currentDocumentObject[item.docId];
        document.getElementById(nextIs.currentIframeName).style.display = 'block';
        document.getElementById(this.currentShowDoc.currentIframeName).style.display = 'none';
        this.currentShowDoc = nextIs;
        document.getElementById(this.currentShowDoc.currentIframeName).contentWindow.optimizePageShow()
        this.currentShowDocIndex = this.currentShowDoc.originIdx
      }
      this.dimissFileList()
    },
    //获取签名印章列表
    //flag true 签名 false 盖章
    setKeyType() {
      this.keyType = this.isSigner === 'true' ? 0 : (this.isSealer === 'true' ? 1 : -1)
      this.keyTypeName = this.keyType === 0 ? '签名' : '盖章'
      if (this.keyType != -1) {
        this.type = 'SIGN'
      } else {
        this.type = 'VIEW'
      }
    },
    //获取文件列表
    getContractResActList() {
      this.iframeHeight = document.getElementById('pdfcontainer').clientHeight
      this.$store.dispatch(this.$LoadShow, true)
      this.$post("/contract/api/getContractResActList?id=" + this.corpsId + '&isSign=' + this.isSigner)
        .then((res) => {
          if (res.success && res.data) {
            //console.log('res-=',res)
            this.contractInfo = res.data
            this.resList = res.data.resList
            this.resText = this.resList[0].resName
            this.currentDocumentObject = []
            let theFrag = document.createDocumentFragment()
            this.resList.forEach((doc, idx) => {
              //测试配置
              // if (process.env.NODE_ENV === 'development') {
              // 	if (idx == 0 || idx == 1 || idx == 2 || idx == 3) {
              // 		doc.acted = true
              // 	}
              // }
              this.getIframeSrc(theFrag, doc, idx)
            })
          } else {
            this.$store.dispatch(this.$LoadShow, false)
            this.$Toast(res.message || res.messageDetail || '没有获取到合同文件，请返回重试!')
          }
        }).catch(err => {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast('没有获取到合同文件，请返回重试!')
          console.log('getContractResActList', err)
        });
    },
    //
    getIframeSrc(theFrag, doc, idx) {
      let that = this
      this.$store.dispatch(this.$LoadShowLevel, true)
      let url = this.keyType === 0 ? '/seal/api/genMobileSignUrl' : '/seal/api/genMobileSealUrl'
      this.$get(url, {
        contractId: this.contractInfo.contractId,
        corpId: this.contractInfo.corpId,
        docId: doc.docId,
        //resId: doc.resId,
        //seal系统接口入参resid需要的是contractId 2025-3-12改
        resId: this.$store.state.userInfo.staffId + '_' + this.contractInfo.contractId,
      })
        .then(res => {
          this.$store.dispatch(that.$LoadShowLevel, false)
          if (res.success && res.data) {
            if (process.env.NODE_ENV === 'development') {
              // doc.src = doc.src.replace('signetType=1','signetType=0')
              let urls = res.data.split('?')
              doc.src = '/seal/index?host=http://10.17.48.94:8060&' + urls[1]
            } else {
              doc.src = res.data
            }
            this.setIframeSrc(theFrag, doc, idx)
          } else {
            this.$Toast(res.message || res.messageDetail || '获取签章组件重定向链接失败,请重试！')
          }
        }).catch(err => {
          this.$store.dispatch(this.$LoadShowLevel, false)
          console.log('genMobileSignUrl/genMobileSealUrl', err)
          this.$Toast('获取签章组件重定向链接失败,请重试！')
        })
    },
    //
    setIframeSrc(theFrag, doc, idx) {
      let data = this.resList.filter(item => {
        return !item.src
      })
      if ((Array.isArray(data) && data.length === 0) || !data) {
        this.resList.forEach((doc, idx) => {
          let iframeName = 'Iframe' + idx;
          this.currentDocumentObject[doc.docId] = {
            documentType: doc.isAttachment,
            attachment: doc.isAttachment,
            acted: doc.acted,
            documentName: doc.resName,
            documentID: doc.docId,
            fileID: doc.resId,
            originIdx: idx,
            currentIframeName: iframeName,
            prevIframeID: idx === 0 ? null : this.resList[idx - 1].docId,
            nextIframeID: idx === this.resList.length - 1 ? null : this.resList[
              idx + 1].docId
          };
          let theIframe = document.createElement('iframe');
          theIframe.setAttribute('id', iframeName);
          theIframe.setAttribute('class', 'iframe-style');
          theIframe.setAttribute('style', 'display:none;height:' + this
            .iframeHeight + 'px');
          // 把第1个文档作为默认显示文档
          if (idx === this.currentShowDocIndex) {
            this.currentShowDoc = this.currentDocumentObject[doc.docId];
            theIframe.setAttribute('style', 'display:block;height:' + this
              .iframeHeight + 'px');
            this.currentShowDocIndex = idx
          }
          theIframe.setAttribute('src', doc.src);
          theFrag.appendChild(theIframe);
        })
        document.getElementById('pdfcontainer').appendChild(theFrag)
      }
    },
    //切换为查看状态 
    //flag true view,false sign
    switchSignToView(flag) {
      if (flag) {
        this.refreshIframe(1)
      } else {
        this.clickId = ''
        this.resList.forEach((doc, idx) => {
          document.getElementById('pdfcontainer').removeChild(document.getElementById(
            this.currentDocumentObject[doc.docId].currentIframeName));
        })
        this.getContractResActList()
      }
    },
    //刷新合同
    //flag 1 完成签署刷新，0 继续签署刷新
    refreshIframe(flag) {
      // console.log('submitData.models-=', this.submitData.models)
      // console.log('currentDocumentObject-=', this.currentDocumentObject)
      this.$store.commit('changeContractStatus', true)
      //pdf页面本地刷新
      let keys = Object.keys(this.currentDocumentObject);
      keys.every((key, idx) => {
        let tempIframe = document.getElementById(this
          .currentDocumentObject[key].currentIframeName);
        let scrollTop = 0
        if (this.currentDocumentScrollTop.length > 0) {
          scrollTop = this.currentDocumentScrollTop[idx]
        }
        let model = this.submitData.models.find(item => item.params.docId === this
          .currentDocumentObject[key].documentID)
        //console.log('model-=', this.submitData.models, this.currentDocumentObject[key], model)
        if (model) {
          //console.log('---model----', model.params.fileId)
          tempIframe.contentWindow.refresh(model.params.fileId, scrollTop, flag)
        } else {
          tempIframe.contentWindow.refresh('', scrollTop, flag)
        }
        return true
      })
      this.submitData = {
        models: [],
      }
    },
    //进入页面活体认证
    faceCompareAuth() {
      this.pop_show = false
      realLiveAuth({
        type: '2',
        staffId: this.$store.state.loginInfo.staffId
      })
    },
    //人脸对比成功
    faceCompareAuthSucced(requestId) {
      //获取verifyToken
      this.getVerifyToken(requestId)
    },
    //人脸对比失败
    faceCompareAuthFailed(message) {
      if (this.submitData.models[0].params.verifyMode === 'FACE_SMS') {
        this.$Toast('调用人脸对比失败，请使用验证码签约！')
        this.popShow(true)
      } else {
        this.$Toast(message || '调用人脸对比失败，请重试！')
      }
    },
    //获取verifyToken
    getVerifyToken(requestId) {
      this.$sealp("/api/face/verifyState", {
        requestId: requestId,
        staffId: this.submitData.models[0].params.staffId,
        resId: this.submitData.models[0].params.resId,
        corpId: this.submitData.models[0].params.corpId,
      }, this.submitData.models[0].params.appCode).then((res) => {
        if (res.success && res.data) {
          this.verifyToken = res.data
          //获取verifyToken成功后开始签章流程
          this.getSignFileHash(0)
          //获取verifyToken成功后轮询页面并赋值然后加载
          //this.setIframeVerifyToken(res.data.verifyToken)
        } else {
          this.$Toast(res.message || res.messageDetail || '人脸对比失败，请重试！')
        }
      })
    },
    //
    verifyTokenSumbit() {
      if (Array.isArray(this.submitData.models) && this.submitData.models.length > 0) {
        if (this.keyType === 0) {
          //循环提交签名
          this.signetSumbit(0)
        } else {
          this.clickId = this.Tool.generateUUID()
          if (this.Tool.isNoEmty(this.submitData.models[0].params.verifyToken)) {
            this.verifyToken = this.submitData.models[0].params.verifyToken
            //测试跳过人脸对比
            this.getSignFileHash(0)
            //开始盖章流程
            //this.sealerSumbitFlow()
          } else {
            if (this.submitData.models[0].params.verifyMode === 'SMS') {
              this.popShow()
            } else {
              this.faceCompareAuth()
            }
          }
        }
      } else {
        // console.log('wanchengqianming')
        // return
        if (this.keyType === 0) {
          this.completeSignOrSeal(0)
        } else {
          this.completeSignOrSeal(1)
        }
      }
    },
    //提交
    sumbit() {
      if (this.keyType === 0) {
        //循环提交签名
        this.signetSumbit(0)
      } else {
        //测试跳过人脸对比
        this.getSignFileHash(0)
        //开始盖章流程
        //this.sealerSumbitFlow()
      }
    },
    //签名提交
    signetSumbit(index) {
      //console.log(this.submitData)
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealps('/api/doc/sign/event', JSON.stringify({
        docId: this.submitData.models[index].params.docId,
        segId: this.submitData.models[index].params.segId,
        lockId: this.submitData.models[index].params.lockId,
        fileId: this.submitData.models[index].params.fileId,
        corpId: this.submitData.models[index].params.corpId,
        staffId: this.submitData.models[index].params.staffId,
        allowSignDate: this.submitData.models[index].params.allowSignDate,
        pages: this.submitData.models[index].pages
      }), {
        appCode: this.submitData.models[index].params.appCode,
        //verifyToken: this.verifyToken
      }).then((res) => {
        if (res.success) {
          // if (res.data.renewedVerifyToken) {
          // 	this.verifyToken = res.data.renewedVerifyToken
          // }
          this.currentDocumentObject[this.submitData.models[index].params.docId].acted = true
          this.submitData.models[index].params.lockId = res.data.lockId
          this.submitData.models[index].params.fileId = res.data.fileId
          if (index === this.submitData.models.length - 1) {
            this.$store.dispatch(this.$LoadShow, false)
            //this.$Toast('签名成功!')
            this.completeSignOrSeal(0)
            //this.refreshIframe(0)
          } else {
            index++
            if (this.submitData.models[index - 1].params.docId === this.submitData.models[
              index].params.docId) {
              this.submitData.models[index].params.lockId = res.data.lockId
              this.submitData.models[index].params.fileId = res.data.fileId
            }
            this.signetSumbit(index)
          }
        } else {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast(res.message || res.messageDetail || '签名失败，请重试!')
          this.refreshIframe(0)
        }
      }).catch((error) => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('/api/doc/sign/event', error)
        this.$Toast('签名失败，请重试!')
        this.refreshIframe(0)
      })
    },
    //盖章提交流程开始
    sealerSumbitFlow() {
      //人脸对比认证
      realLiveAuth({
        type: '2',
        staffId: this.$store.state.loginInfo.staffId,
        corpId: this.corpId
      })
      // this.startFaceCompareAuth()
      //循环
      //根据章获取文件hash使用证书签署
      //签署文件
    },
    //获取印章文件hash值 
    //index 循环请求
    getSignFileHash(index) {
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealps('/api/doc/sign/pkcs', JSON.stringify({
        docId: this.submitData.models[index].params.docId,
        segId: this.submitData.models[index].params.segId,
        lockId: this.submitData.models[index].params.lockId,
        fileId: this.submitData.models[index].params.fileId,
        certId: this.submitData.models[index].certId,
        signetImgId: this.submitData.models[index].signetId,
        corpId: this.submitData.models[index].params.corpId,
        staffId: this.submitData.models[index].params.staffId,
        allowSealDate: this.submitData.models[index].params.allowSealDate,
        page: {
          x: this.submitData.models[index].x,
          y: this.submitData.models[index].y,
          index: this.submitData.models[index].index,
          //zoom: this.submitData.models[index].zoom,
          timeFlag: this.submitData.models[index].timeFlag,
          reason: this.submitData.models[index].reason
        },
        isMobile: true,
        enKey: ''
      }), {
        appCode: this.submitData.models[index].params.appCode,
        verifyToken: this.verifyToken
      }).then((res) => {
        if (res.success && res.data) {
          if (res.data.renewedVerifyToken) {
            this.verifyToken = res.data.renewedVerifyToken
          }
          // for (let i = 0; i <= index; i++) {
          // 	if (this.submitData.models[i].params.docId === this.submitData.models[index].params
          // 		.docId) {
          // 		this.submitData.models[i].params.lockId = res.data.lockId
          // 		this.submitData.models[i].params.fileId = res.data.fileId
          // 	}
          // }
          //缓存返回数据
          //this.submitData.models[index].data = res.data
          this.signFlowSealHashSign(index, res.data, this.$store.state.loginInfo.userName)
          // let result = getSealHashSign(res.data.signingAttr.certSn, res.data.signingPkcs,
          // 	this.$store.state.loginInfo.userName)
          // // if (index == 2) {
          // // 	result = result.replaceAll('1', '2').replaceAll('A', '2')
          // // }
          // if (result) {
          // 	this.signFlowItemFinish(index, result, res.data)
          // } else {
          // 	this.$store.dispatch(this.$LoadShow, false)
          // 	this.$Toast('证书签名失败，请检查用户证书！')
          // }
        } else {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast(res.message || res.messageDetail || '盖章获取数据失败，请联系管理员!')
          this.switchSignToView(0)
        }
      }).catch((error) => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('/api/doc/sign/pkcs', error)
        this.$Toast('盖章获取数据失败，请重试!')
        this.switchSignToView(0)
      })
    },
    //
    signFlowSealHashSign(index, hashdata, userName) {
      getSealHashSign(hashdata.signingAttr.certSn, hashdata.signingPkcs, userName).then(res => {
        if (res) {
          // if (index == 2) {
          // 	res = res.replaceAll('1', '2').replaceAll('A', '2')
          // }
          this.signFlowItemFinish(index, res, hashdata)
        } else {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast('证书签名失败，请检查用户证书！')
        }
      }).catch(err => {
        this.$store.dispatch(this.$LoadShow, false)
        this.$Toast('证书签名失败，请检查用户证书！')
      })
    },
    //提交签署一个印章数据
    signFlowItemFinish(index, signdata, data) {
      let isFinish = false
      if (index < this.submitData.models.length - 1) {
        if (this.submitData.models[index].params.docId !== this.submitData.models[index + 1].params.docId) {
          isFinish = true
        }
      }
      if (index === this.submitData.models.length - 1) {
        isFinish = true
      }
      this.$sealps('/api/doc/sign/save', JSON.stringify({
        docId: this.submitData.models[index].params.docId,
        segId: this.submitData.models[index].params.segId,
        // lockId: this.submitData.models[index].params.lockId,
        // fileId: this.submitData.models[index].params.fileId,
        lockId: data.lockId,
        fileId: data.fileId,
        corpId: this.submitData.models[index].params.corpId,
        staffId: this.submitData.models[index].params.staffId,
        signedData: signdata,
        signingAttr: data.signingAttr,
        qrRequestId: data.qrRequestId,
        isFinished: isFinish,
        clkId: this.clickId,
        enKey: ''
      }), {
        appCode: this.submitData.models[index].params.appCode,
        verifyToken: this.verifyToken
      }).then((res) => {
        if (res.success && res.data) {
          this.retryIndex = 0
          if (res.data.renewedVerifyToken) {
            this.verifyToken = res.data.renewedVerifyToken
          }
          this.currentDocumentObject[this.submitData.models[index].params.docId].acted = true
          for (let i = 0; i <= index; i++) {
            if (this.submitData.models[i].params.docId === this.submitData.models[index].params
              .docId) {
              this.submitData.models[i].params.lockId = res.data.lockId
              this.submitData.models[i].params.fileId = res.data.fileId
            }
          }
          if (index === this.submitData.models.length - 1) {
            this.$store.dispatch(this.$LoadShow, false)
            //this.$Toast('盖章成功!')
            if (process.env.NODE_ENV === 'development') {
              this.completeSignOrSeal(1)
              //变成预览模式
              //this.refreshIframe(0)
            } else {
              this.completeSignOrSeal(1)
            }
          } else {
            index++
            //不同文档连续盖章时，fileId和lockId不切换,相同文档连续盖章时，fileId和lockId需要替换成新的
            if (this.submitData.models[index - 1].params.docId === this.submitData.models[
              index].params.docId) {
              this.submitData.models[index].params.lockId = res.data.lockId
              this.submitData.models[index].params.fileId = res.data.fileId
            }
            this.getSignFileHash(index)
          }
        } else {
          //当ios端签名数据验证失败时，重新获取签名数据 重新 盖章 
          if (res.code == 'VE001') {
            if (this.retryIndex >= 5) {
              this.retryIndex = 0
              this.$store.dispatch(this.$LoadShow, false)
              this.showMessageInfoAlert('盖章失败，请继续拖动印章到文件还未盖章处，点击【签署文件】完成盖章!', 0, '关闭')
            } else {
              this.retryIndex++
              this.submitData.models[index].params.lockId = data.lockId
              //this.submitData.models[index].params.fileId = data.fileId
              this.getSignFileHash(index)
            }
            this.retryCount++
          } else {
            this.$store.dispatch(this.$LoadShow, false)
            this.$Toast(res.message || res.messageDetail || '盖章失败，请重试!')
            this.switchSignToView(0)
          }
          console.log('retryIndex-=', this.retryIndex, this.retryCount)
          // this.$store.dispatch(this.$LoadShow, false)
          // this.$Toast(res.message || res.messageDetail || '盖章失败，请重试!')
          // this.switchSignToView(0)
        }
      }).catch((error) => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('/api/doc/sign/save', error)
        this.$Toast('盖章失败，请重试!')
        this.switchSignToView(0)
      })
    },
    //撤销盖章
    cancleSignetMake(index) {
      this.$store.dispatch(this.$LoadShow, true)
      this.$sealps('/api/doc/sign/revert', JSON.stringify({
        docId: this.submitData.models[index].params.docId,
        lockId: this.submitData.models[index].params.lockId,
        fileId: this.submitData.models[index].params.fileId,
        staffId: this.submitData.models[index].params.staffId,
      }), {
        appCode: this.submitData.models[index].params.appCode,
        verifyToken: this.verifyToken
      }).then((res) => {
        if (res.success && res.data) {
          if (res.data.renewedVerifyToken) {
            this.verifyToken = res.data.renewedVerifyToken
          }
          if (index === this.submitData.models.length - 1) {
            this.$store.dispatch(this.$LoadShow, false)
            this.$Toast('撤销成功!')
            this.switchSignToView(true)
          } else {
            index++
            this.cancleSignetMake(index)
          }
        } else {
          this.$store.dispatch(this.$LoadShow, false)
          this.$Toast(res.message || res.messageDetail || '撤销失败，请重试!')
        }
      }).catch((error) => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('/api/doc/sign/revert', error)
        this.$Toast('撤销失败，请重试!')
      })
    },
    //完成签署
    //type 签名 0 盖章 1
    completeSignOrSeal(type) {
      // 预览模式
      // this.switchSignToView(1)
      // return
      this.$store.dispatch(this.$LoadShow, true)
      this.$post('/contract/api/complete', {
        completeType: type,
        contractId: this.contractInfo.contractId,
        corpId: this.contractInfo.corpId,
        lockId: type ? this.$route.query.zthcLockId : '',
      }).then((res) => {
        this.$store.dispatch(this.$LoadShow, false)
        if (res.success) {
          //预览模式
          this.switchSignToView(1)
          this.$Toast('完成' + this.keyTypeName)
        } else {
          this.$Toast(res.message || res.messageDetail || '完成签约失败，请联系管理员!')
        }
      }).catch((error) => {
        this.$store.dispatch(this.$LoadShow, false)
        console.log('/contract/api/complete', error)
        this.$Toast('完成签约失败，请重试！')
      })
    },
    //测试文件盖章
    testAllPageSeal() {
      let pages = this.submitData.models
      this.submitData = {
        models: []
      }
      pages.forEach((item, index) => {
        let limit = item.index
        let startPage = 1
        for (let i = startPage; i <= limit; i++) {
          let start = 0
          let end = 20
          // if (i == 2) {
          // 	end = 14
          // }
          for (let j = start; j < end; j++) {
            let temp = JSON.parse(JSON.stringify(item))
            temp.index = i
            let a = j % 4
            let b = j / 4
            if (a == 0) {
              temp.x = 0.017
            }
            if (a == 1) {
              temp.x = 0.26
            }
            if (a == 2) {
              temp.x = 0.51
            }
            if (a == 3) {
              temp.x = 0.76
            }
            if (b >= 0 && b < 1) {
              temp.y = 0.8
            }
            if (b >= 1 && b < 2) {
              temp.y = 0.6
            }
            if (b >= 2 && b < 3) {
              temp.y = 0.4
            }
            if (b >= 3 && b < 4) {
              temp.y = 0.2
            }
            if (b >= 4) {
              temp.y = 0.005
            }
            // console.log('iiii-jjjj-=', i, j, a, b)
            // console.log('item-temp-=', item, temp)
            this.submitData.models.push(temp)
          }
        }
      })
      console.log('testAllPageSeal-submitData', this.submitData)
      this.verifyTokenSumbit()
    },
    //核查签名或盖章数据
    checkSignDatas() {
      let that = this
      //console.log('currentDocumentObject-=', this.currentDocumentObject)
      this.submitData.models = []
      let keys = Object.keys(this.currentDocumentObject);
      //console.log(keys)
      let canSubmit = keys.every((key, idx) => {
        //console.log(key)
        let tempIframe = document.getElementById(that
          .currentDocumentObject[
          key].currentIframeName);
        //console.log(tempIframe)
        if (tempIframe) {
          //console.log('获取到的参数--=',tempIframe.contentWindow.getQueryParams())	
          that.currentDocumentScrollTop.push(tempIframe.contentWindow
            .getPageScrollTop())
          let theIframeSealData = that.keyType === 0 ? tempIframe
            .contentWindow.submitTheDataOther() : tempIframe
              .contentWindow.submitTheData();
          if (!that.currentDocumentObject[key].acted &&
            (!theIframeSealData || !Array.isArray(theIframeSealData
              .pages) || theIframeSealData.pages.length === 0)) {
            Dialog.alert({
              title: '提示',
              message: '文档《' + that
                .currentDocumentObject[key].documentName +
                '》还未' +
                that.keyTypeName + '，或请将' + that.keyTypeName +
                '图片拖动到文件待' + that.keyTypeName + '处！',
              confirmButtonText: '关闭',
              confirmButtonColor: '#0277FC'
            }).then(() => { });
            return false;
          }
          if (theIframeSealData && Array.isArray(theIframeSealData
            .pages) && theIframeSealData.pages.length > 0) {
            let filterPageY = theIframeSealData.pages.filter(item => {
              return item.y < 0
            })
            if (filterPageY[0]) {
              filterPageY.forEach(page => {
                Dialog.alert({
                  title: '提示',
                  message: '文档《' + that
                    .currentDocumentObject[key].documentName +
                    '》第' + page.index + '页存在无效位置' +
                    that.keyTypeName + '，请检查拖动一下位置！',
                  confirmButtonText: '关闭',
                  confirmButtonColor: '#0277FC'
                }).then(() => { });
              })
              return false;
            }
          }
          console.log('---签名盖章数据---=', theIframeSealData)
          //签名按文档循环提交，盖章按章循环提交
          if (that.keyType === 0) {
            if (theIframeSealData && Array.isArray(theIframeSealData
              .pages) && theIframeSealData.pages.length > 0) {
              that.submitData.models.push(theIframeSealData)
            }
          } else {
            if (theIframeSealData && Array.isArray(theIframeSealData
              .pages) && theIframeSealData.pages.length > 0) {
              that.submitData.models = that.submitData.models.concat(
                theIframeSealData.pages);
            }
          }
          return true
        } else {
          //that.$Toast('无法获取' + that.keyTypeName + '页面信息！')
          return false;
        }
      });
      return canSubmit
    },
    //接受处理iframe消息
    handlerMessage() {
      let that = this
      window.addEventListener('message', (event) => {
        this.keyTypeName = this.keyType === 0 ? '签名' : '盖章'
        //console.log(event.data.data)
        let postData = event.data.data;
        if (postData && postData.type) {
          switch (postData.type) {
            //签署文件操作提交内容
            case 'sumbit':
              //console.log('submitData-=', that.submitData)
              if (this.checkSignDatas()) {
                Dialog.confirm({
                  title: '提示',
                  message: '请确认文档中所有' + that.keyTypeName + '位置都已拖动' + that
                    .keyTypeName +
                    '图片，点击签署按钮后将完成' + that.keyTypeName + '，不可更改。',
                  confirmButtonText: '确定',
                  confirmButtonColor: '#0277FC'
                })
                  .then(() => {
                    //console.log('提交', that.currentDocumentScrollTop)
                    //that.verifyTokenSumbit()
                    if (process.env.NODE_ENV === 'development') {
                      that.verifyTokenSumbit()
                      //that.testAllPageSeal()
                    } else {
                      that.verifyTokenSumbit()
                    }
                  })
                  .catch(() => { });
              }
              break;
            //显示iframe中的消息
            case 'toast':
              console.log('toast', postData)
              that.$Toast(postData.data)
              break;
            //pdf滑动时条件弹窗消失
            case 'ResListShow':
              that.dimissFileList()
              //console.log('FileListShow')
              break;
            //pdf加载时改弹窗消失
            case 'loaded':
              //console.log('加载消失')
              that.$store.dispatch(that.$LoadShow, false)
              break;
            case 'loading':
              //console.log('加载消失')
              that.$store.dispatch(that.$LoadShow, true)
              break;
            case 'qrcode':
              console.log('qrcode', postData)
              // if(postData&&postData.data){
              // 	let tmp = postData.data.split('||')
              // 	if(tmp[1]){
              // 		Dialog.confirm({
              // 				title: '提示',
              // 				message: '识别到合同二维码内容：' + tmp[1] + '，需要跳转到存证报告页面吗？',
              // 				confirmButtonText: '确定',
              // 				confirmButtonColor: '#0277FC'
              // 			})
              // 			.then(() => {
              // 				that.$router.push({
              // 					path: '/contractevidenceinfo',
              // 					query: {
              // 						contractCode: that.contractInfo.contractCode,
              // 					}
              // 				})
              // 			})
              // 			.catch(() => {
              // 			});
              // 	}
              // }
              break;
          }
        }
      })
    },
    //
    showMessageInfoAlert(message, type, confirmButtonText = '关闭') {
      Dialog.alert({
        title: '提示',
        message: message,
        confirmButtonText: confirmButtonText,
        confirmButtonColor: '#0277FC'
      }).then(() => {
        if (type === 0) {
          this.switchSignToView(0)
        }
      });
    },
    //初始化
    init() {
      //this.contractId = this.$route.query.contractId
      //this.corpId = this.$route.query.corpId
      this.corpsId = this.$route.query.corpsId
      this.isSigner = this.$route.query.isSigner
      this.isSealer = this.$route.query.isSealer
      this.bizId = this.$route.query.bizId
      this.contractType = this.$route.query.contractType
      this.setKeyType()
      this.getContractResActList()
      this.handlerMessage()
      //ios版每次使用前需要初始化
      initIosAuth()
      //合同滑动时 是否通知本页面
      window.localStorage.setItem('ResListShow', this.reslistShow)
      //
      //this.popShow()
    },
  },
  mounted() {
    this.init()
  },
  created() {
    window.faceCompareAuthSucced = this.faceCompareAuthSucced
    window.faceCompareAuthFailed = this.faceCompareAuthFailed
  },
  beforeDestroy() {
    //自动回收
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/global.css";

.sms_pop_parent {
  padding: 0.5rem 0;

  .pop_content {
    padding: 0 1rem;
  }
}

// .iframe-style {
// 	position: absolute;
// 	display: block;
// 	border: 0;
// 	top: 0;
// 	top: calc(constant(safe-area-inset-top));
// 	top: calc(env(safe-area-inset-top));
// 	left: 0;
// 	width: 100vw;
// 	height: calc(85vh);
// 	height: calc(85vh + constant(safe-area-inset-top) + constant(safe-area-inset-bottom));
// 	height: calc(85vh + env(safe-area-inset-top) + env(safe-area-inset-bottom));
// 	background: #E8E8E8;
// }
</style>